import * as React from "react";

function Reset() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="21" viewBox="0 0 18 21" fill="none">
            <path d="M6.99993 14.5H1.99993V19.5M16.4175 13.4968C15.8569 14.8846 14.9181 16.0872 13.708 16.968C12.4979 17.8488 11.0649 18.3725 9.57204 18.4795C8.07915 18.5865 6.58617 18.2726 5.2628 17.5734C3.93943 16.8742 2.83875 15.8177 2.08587 14.5241M10.9999 6.5H15.9999V1.5M1.58246 7.50315C2.14314 6.1154 3.08189 4.91278 4.292 4.03197C5.50211 3.15116 6.93505 2.62749 8.42795 2.52047C9.92085 2.41346 11.4138 2.7274 12.7372 3.42661C14.0606 4.12582 15.1612 5.18226 15.9141 6.47584" 
            stroke="#838280" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}

export default Reset;
